/** Parse a single CSV line respecting quoted fields. */
export function parseCsvLine(line) {
    const result = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i += 1) {
        const ch = line[i];
        if (ch === '"') {
            if (inQuotes && line[i + 1] === '"') {
                current += '"';
                i += 1;
            } else {
                inQuotes = !inQuotes;
            }
        } else if (ch === ',' && !inQuotes) {
            result.push(current.trim());
            current = '';
        } else {
            current += ch;
        }
    }
    result.push(current.trim());
    return result;
}

/** Parse CSV text into { header, rows }. */
export function parseCsv(text) {
    const normalized = String(text || '')
        .replace(/^\uFEFF/, '')
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .trim();

    if (!normalized) {
        return { header: [], rows: [] };
    }

    const lines = normalized.split('\n').filter((line) => line.trim().length > 0);
    if (!lines.length) {
        return { header: [], rows: [] };
    }

    const header = parseCsvLine(lines[0]).map((h) => h.trim());
    const rows = lines.slice(1).map((line) => {
        const values = parseCsvLine(line);
        return header.reduce((obj, key, index) => {
            obj[key] = values[index] !== undefined ? values[index] : '';
            return obj;
        }, {});
    });

    return { header, rows };
}

/** Keep rows that look like Tastytrade position lines. */
export function filterTastytradeRows(rows) {
    return rows.filter((row) => {
        const symbol = String(row.Symbol || row.symbol || '').trim();
        const type = String(row.Type || row.type || '').trim();
        return symbol.length > 0 && type.length > 0 && type.toUpperCase() !== 'CRYPTO';
    });
}
